import { render, staticRenderFns } from "./EdicaoProgressao.vue?vue&type=template&id=4b024aa4&scoped=true"
import script from "./EdicaoProgressao.vue?vue&type=script&lang=js"
export * from "./EdicaoProgressao.vue?vue&type=script&lang=js"
import style0 from "./EdicaoProgressao.vue?vue&type=style&index=0&id=4b024aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b024aa4",
  null
  
)

export default component.exports